/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useStateContext } from "../../../../contexts/ThemeContext";
import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import PageLanguage from "./PageLangauge";
import { updatePageName } from "../../../../redux/slices/user/userSlice";
import { useDispatch, useSelector } from "react-redux";

import * as yup from "yup";

import GrrenFillCheck from "../../../../assets/tick-circle.png";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { toast } from "react-hot-toast";

import { resetUser as userReset } from "../../../../redux/slices/user/userSlice";
import useLocales from "../../../../hooks/useLocales";
import useSettings from "../../../../hooks/useSettings";
import MobileBottomLogoutBtn from "../../../../components/dashboard/MobileBottomLogoutBtn";
import {
  logoutUser,
  resetUser as resetAuthUser,
} from "../../../../redux/slices/auth/authSlice";
import { resetLinkList } from "../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { RiErrorWarningLine } from "react-icons/ri";
import { Helmet } from "react-helmet";

import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import httpRequest from "../../../../axios/index";
import { setAllLangs } from "../../../../redux/slices/Languages/LanguagesSlice";

const baseUrl = process.env.REACT_APP_API_URL;

const Page = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { setActiveSettingSubNav } = useStateContext();
  const [search, setSearch] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [nameAvailable, setNameAvailable] = useState(null);
  const [nameLoading, setNameLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(false);

  const { themeDirection } = useSettings();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const schema = yup.object().shape({
    pageName: yup
      .string()
      .max(40)
      .test(
        "no-symbols",
        `${translate("addBlock.page_name_cannot")}`,
        (value) => /^[a-zA-Z0-9\s]+$/.test(value)
      )
      .required(`${translate("auth.page_name_required")}`)
      .nullable(),
  });

  const {
    register,
    handleSubmit,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const userId = useSelector((state) => state?.user?.user?.userid);

  // update account details response
  const {
    updatePageNameLoading,
    updatePageNameSuccess,
    updatePageNameState,
    updatePageNameError,
    updatePageNameErrorMsg,
  } = useSelector((state) => state?.adminUser);
  const { status: statusupdatePageName, message: messageupdatePageName } =
    useSelector((state) => state?.adminUser?.updatePageNameState);

  useEffect(() => {
    if (statusupdatePageName === "Success" && updatePageNameSuccess) {
      toast.success(messageupdatePageName);
      dispatch(logoutUser());
      dispatch(resetLinkList());
      dispatch(resetAuthUser());
      navigate("/auth/login");
    } else if (statusupdatePageName === "failed" && updatePageNameSuccess) {
      toast.error(messageupdatePageName);
    }
    if (updatePageNameError) {
      toast.error(updatePageNameErrorMsg);
    }
    dispatch(userReset());
  }, [updatePageNameLoading, updatePageNameState]);

  //  default values for pageName
  const user_data = useSelector(
    (state) => state?.adminUser?.viewUserData?.user_data
  );
  useEffect(() => {
    setValue("pageName", user_data?.pageName);
  }, [user_data]);

  const pageNameInputChangeHandler = async (e) => {
    if (e.target.value !== "") {
      if (!/^[a-zA-Z0-9\s]+$/.test(e.target.value)) {
        setError("pageName", {
          notValid: {
            value: true,
            message: `${translate("addBlock.page_name_cannot")}`,
          },
        });
      } else {
        clearErrors("pageName"); // Clear the error for 'pageName' field

        const formData = {
          pageName: e.target.value ? e.target.value : null,
        };
        if (!errors?.pageName) {
          // await dispatch(validatePageName(formData));
          setNameLoading(true);
          setTimeout(() => {
            setSearch(formData);
          }, 100);
        }
      }
    } else {
      setNameAvailable(null);
      setNameLoading(false);
      setError("pageName", {
        required: {
          value: true,
          message: `${translate("auth.page_name_required")}`,
        },
      });
    }
  };

  useEffect(() => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearchTimeout(
      setTimeout(() => {
        if (search) {
          validatePageName(search);
        }
      }, 900)
    );

    return () => clearTimeout(searchTimeout);
  }, [search]);

  const [isOpen, setIsOpen] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const validatePageName = async (pageName) => {
    const path = "/api/user/validatePageName";
    const url = baseUrl + path;

    try {
      const response = await axios.post(url, pageName);
      setNameLoading(false);
      // console.log(response.data, "success");
      if (response.data.status === true) {
        setNameAvailable(response.data);
      } else {
        setError("pageName", {
          notAvailable: {
            value: true,
            message: `${translate("auth.this_username_is_already_taken")}`,
          },
        });
        setNameAvailable(response.data);
        setNameLoading(false);
      }
      return response?.data;
    } catch (error) {
      setNameLoading(false);
      toast.error(error.message);
      return error;
    }
  };
  const savePage = async (e) => {
    // const { pageName } = e.pageName;
    // e.prevent.default()
    let data = {
      pageName: e.pageName,
      userId: userId,
    };
    setIsOpen(data);
  };
  const confirmed = async () => {
    setSubLoading(true);
    await dispatch(updatePageName(isOpen));
    setSubLoading(false);
    setIsOpen(null);
    setIsModalOpen(false);
    return;
  };

  useEffect(() => {
    setActiveSettingSubNav("page");
    return () => {
      setActiveSettingSubNav(null);
    };
  }, []);

  const [addedLanguages, setAddedLanguages] = useState([]);

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const languagesShow = async () => {
    if (!user?.userid) {
      dispatch(setAllLangs({ addedLanguages: [] }));
      return null;
    }
    try {
      const url = `/api/user/languages/${user?.userid}`;
      const response = await httpRequest.get(url);
      const resultLanguage = response?.data?.data;
      const status = response?.data?.status;

      if (status === "success") {
        setAddedLanguages(resultLanguage);
        dispatch(setAllLangs({ addedLanguages: resultLanguage }));
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    languagesShow();
  }, []);

  const handleButtonClick = () => {
    if (!nameLoading && nameAvailable?.status === true) {
      setIsModalOpen(true);
    }
    if (nameAvailable?.status === false) {
      toast.error(nameAvailable?.message);
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Page Setting | Bil.Bio</title>
        <meta property="og:title" content="Page Setting | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      {isModalOpen && (
        <div className="fixed inset-0 bg-[#00000066] backdrop-blur-md flex justify-center items-center h-screen w-screen z-50">
          <div className="p-5 mx-6 bg-white dark:bg-dark-primary px-7 rounded-2xl ">
            <div className="text-center">
              <div className="flex justify-center">
                <RiErrorWarningLine className="text-[120px] text-state_color_alert" />
              </div>
              <p className="mb-10 text-body_copy1 dark:text-color_v1_dark">
                Once page name is changed, previously <br /> shared link will
                stop working
              </p>
            </div>
            <div className="flex items-center justify-end gap-3">
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-small3_b lg:text-small1_bold text-heading_color dark:text-color_v1_dark"
              >
                CANCEL
              </button>

              <button
                disabled={subLoading}
                onClick={() => confirmed()}
                className={`rounded-full w-fit px-5 py-[6px] pt-[7px] bg-main_color text-white text-small3_b lg:text-small1_bold ${
                  subLoading ? "opacity-70 lg:px-10" : "md:px-5"
                }`}
              >
                {subLoading ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  `CONTINUE`
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="md:hidden mt-10 mb-10 ">
        <Link className="flex items-center gap-3" to={"/dashboard/setting"}>
          <div className=" flex items-center justify-center">
            {darkMode ? (
              <LeftArrowDark
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            ) : (
              <LeftArrow
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            )}
          </div>
          <h6 className="w-full text-body_copy2 dark:text-color_v1_dark">
            {translate("addBlock.page")}
          </h6>
        </Link>
      </div>
      <div className="w-full bg-white  dark:bg-dark-secondary rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-6 lg:p-[50px] md:mb-[118px]">
        {/*<div className="flex flex-col min-h-[calc(100vh_-_285px)] lg:min-h-[calc(100vh_-_335px)] justify-between overflow-y-scroll"> */}
        <form
          onSubmit={handleSubmit((data) => savePage(data))}
          className="flex flex-col min-h-[calc(100vh_-_285px)] lg:min-h-[calc(100vh_-_335px)] justify-between overflow-y-scroll"
        >
          <div>
            <h1 className="text-small1_bold text-dark_bg_v1 dark:text-color_v1_dark lg:text-custom_h6">
              {translate("addBlock.page_name")}
            </h1>
            <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-font_dark_color">
              {translate("addBlock.update_your_page_name")}
            </p>
            <hr className="mt-4 lg:mt-5 dark:border-color_dark" />
            <div className="mt-6 lg:mt-[30px]">
              <div
                className={`flex relative z-9999 ${
                  themeDirection === "rtl" ? "flex-row-reverse" : ""
                }`}
              >
                <span className="hidden z-9999 lg:inline-flex items-center p-3 text-small2_b text-main_color bg-main_color bg-opacity-10 rounded-l-md whitespace-nowrap">
                  https://bil.bio.com
                </span>
                <span className="bg-main_color bg-opacity-10 inline-flex z-9999 lg:hidden items-center p-3 text-small2_b text-main_color rounded-l-md whitespace-nowrap">
                  bil.bio
                </span>

                <div
                  className={`w-full flex ${
                    themeDirection === "rtl" ? " justify-end" : ""
                  }`}
                >
                  <div className="relative w-full  z-9999 md:w-auto">
                    <input
                      type="text"
                      className={`rounded-none z-9999 focus:outline-none rounded-r-md ${
                        nameLoading || nameAvailable
                          ? nameLoading || nameAvailable?.status === true
                            ? "pr-[40px]"
                            : ""
                          : ""
                      } bg-light_bg_v5  dark:bg-dark-secondary border block text-small2 w-full dark:text-color_v1_dark sm:w-full lg:text-small1 md:w-full lg:w-[365px] p-[11px] py-[6.5px] px-[15px] dark:caret-white ${
                        errors?.pageName
                          ? "border-state_color_error placeholder:text-state_color_error "
                          : nameAvailable && nameAvailable?.status === true
                          ? "border-state_color_success pr-[35px]"
                          : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
                      } `}
                      {...register("pageName", {
                        required: `${translate("auth.page_name_required")}`,
                      })}
                      onChange={(e) => pageNameInputChangeHandler(e)}
                      id="pageName"
                      placeholder={translate("auth.enter_page_name")}
                    />
                    {!nameLoading &&
                      nameAvailable &&
                      nameAvailable?.status === true &&
                      !errors?.pageName && (
                        <div className="absolute z-9999 right-[13px] inset-y-0 flex text-font_light_color dark:text-color_v1_dark text-small2 sm:text-body_copy2 items-center justify-center">
                          <img src={GrrenFillCheck} alt="" />
                        </div>
                      )}
                    {nameLoading && !errors?.pageName && (
                      <div className="absolute z-9999 right-[13px] sm:right-[15px] inset-y-0 flex items-center justify-center">
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline w-5 h-5 text-heading_color animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#656565"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {errors?.pageName && (
                <small className="text-state_color_error text-small3">
                  {errors?.pageName?.required?.message ||
                    errors?.pageName.message}
                </small>
              )}
              {errors?.pageName?.notAvailable && (
                <small className="text-state_color_error text-small3">
                  {errors?.pageName?.notAvailable?.message}
                </small>
              )}
              {errors?.pageName?.notValid && (
                <small className="text-state_color_error text-small3">
                  {errors?.pageName?.notValid?.message}
                </small>
              )}
            </div>
            <PageLanguage
              addedLanguages={addedLanguages}
              languagesShow={languagesShow}
            />
          </div>

          <div className="mt-6 text-center md:text-end">
            <button
              type="submit"
              onClick={handleButtonClick}
              className={
                "rounded-full w-full md:w-fit  md:p-3 md:px-10 py-[6px] md:pt-[13px] bg-main_color text-white text-small3_b lg:text-small1_bold "
              }
            >
              {translate("addBlock.save_changes")}
            </button>
          </div>
        </form>
      </div>

      <MobileBottomLogoutBtn />
    </>
  );
};

export default Page;
